var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"answeredQuestion"},[_c('label',[_vm._v(_vm._s(_vm.answer.question.label))]),(_vm.answer.answer)?_c('span',{staticClass:"oui"},[_vm._v("Oui")]):_c('span',{staticClass:"non"},[_vm._v("Non")]),_c('img',{staticClass:"del",attrs:{"src":"/assets/icons/cross2.png"},on:{"click":_vm.deleteAnswer}})])
}
var staticRenderFns = []

export { render, staticRenderFns }